module.exports = __webpack_public_path__ + "static/media/HumanBody-DNA1-Illustration.5f2ea6cf.svg";